import { logger } from '@/core/logger';
import { asyncStorage } from '@/core/storage/asyncStorage';
import { CryptoWrapper } from '@/core/wrappers/crypto';

export class EncryptedStorage {
    static async setEncrypted<T>(key: string, value: T | null): Promise<void> {
        try {
            if (value === null) {
                await asyncStorage.removeItem(key);
                logger.debug('EncryptedStorage:removed', { key });
                return;
            }
            const json = JSON.stringify(value);
            const cipher = await CryptoWrapper.encrypt(json);
            await asyncStorage.setItem(key, cipher);
            logger.debug('EncryptedStorage:stored', { key, size: cipher.length });
        } catch (error) {
            logger.error('EncryptedStorage:store-failed', { key, error });
            throw new Error(`EncryptedStorage failed to store key: ${key}`);
        }
    }

    static async getDecrypted<T>(key: string): Promise<T | null> {
        try {
            const payload = await asyncStorage.getItem(key);
            if (!payload) return null;
            const json = await CryptoWrapper.decrypt(payload);
            const parsed = JSON.parse(json) as T;
            logger.debug('EncryptedStorage:retrieved', { key });
            return parsed;
        } catch (error) {
            logger.error('EncryptedStorage:retrieve-failed', { key, error });
            return null;
        }
    }

    static async remove(key: string): Promise<void> {
        try {
            await asyncStorage.removeItem(key);
            logger.debug('EncryptedStorage:removed', { key });
        } catch (error) {
            logger.error('EncryptedStorage:remove-failed', { key, error });
            throw new Error(`EncryptedStorage failed to remove key: ${key}`);
        }
    }
}

export const encryptedStorage = EncryptedStorage;


